module.exports = __webpack_public_path__ + "static/media/correct.779b9dc3.gif";